module.exports = __webpack_public_path__ + "img/sneakers.8555a602.jpg";